import React, { Component } from "react";
import { connect } from "react-redux";
import { NavList } from "./component/navList";
import { UserInfoPart } from "./component/userInfoPart";
import { NavBarRectangle } from "./style";
import { BgWrapper } from "../shared_style";
import { actionCreators } from "./store";
import NoticeBar from "../../pages/dashboard/components/noticeBar";
import profile from "../../utils/profile";
import ContractMaintainanceModeBar from "../../common/maintenance_mode";
import { ACCESS, ACCOUNT } from "../../utils/constants";
import { hasIPMAccountIntegration } from "utils/helpers";
import IntegrationErrorBanner from "common/header/component/integration_error_banner/banner";
import DemoModeBanner from "./component/demo_mode_banner/banner";
class Header extends Component {
  constructor(props) {
    super(props);
    this.changeAccount = this.changeAccount.bind(this);
    this.state = {
      canAccessAccount: false,
    };
  }
  changeAccount(accountId) {
    window.location = `/dashboard?account_id=${accountId}`;
    this.props.changeAccount(accountId);
  }
  render() {
    const {
      due_projects,
      due_contracts,
      profileInfo,
      setupExpand,
      handleNotice,
      is_help_desk_mode,
      showSubscriptionNotice,
      subscriptionDetails,
      closeSubscriptionNotice,
      showSubscriptionModal,
      showIntegrationError,
      integrationErrorDetails,
      closeIntegrationErrorBanner,
      isDemoMode,
    } = this.props;
    const { canAccessAccount } = this.state;
    const bannerMsg = subscriptionDetails?.getIn(["data", "errors", 1]);
    const accountIndex = localStorage.getItem("paylab_account_id");
    const isIntegrationErrorClosed =
      sessionStorage.getItem("integrationErrorClosed") === "true";

    let navList = [
      {
        code: "dashboard",
        text: "Dashboard",
        num: 0,
        link: "/dashboard",
        permission: true,
        disabled: false,
      },
      {
        code: "projects",
        text: "Projects",
        num: due_projects,
        link: "/projects",
        permission: true,
        disabled: false,
      },
      {
        code: "contacts",
        text: "Contacts",
        num: 0,
        link: "/contacts",
        permission: true,
        disabled: false,
      },
      {
        code: "manage-account",
        text: "Manage Account",
        num: 0,
        link: "/manage-account/view",
        permission: canAccessAccount,
        disabled: isDemoMode,
      },
    ];
    return (
      <>
        {isDemoMode && <DemoModeBanner />}
        <NavBarRectangle className="dashboard_step1">
          <BgWrapper className="header">
            <NavList
              navList={navList}
              due_projects={due_projects}
              due_contracts={due_contracts}
            />
            <UserInfoPart
              {...this.props}
              accountIndex={accountIndex}
              profile={profileInfo}
              changeAccount={this.changeAccount}
              canAccessAccount={canAccessAccount}
              handleNotice={(status) =>
                handleNotice("setupExpand", setupExpand, status)
              }
              isDemoMode={isDemoMode}
            />
          </BgWrapper>
        </NavBarRectangle>
        {is_help_desk_mode && <NoticeBar type="help_desk_mode" />}
        <ContractMaintainanceModeBar />
        {showSubscriptionNotice && (
          <NoticeBar
            type="subscription"
            details={bannerMsg}
            closeSubscriptionNotice={closeSubscriptionNotice}
            showSubscriptionModal={showSubscriptionModal}
          />
        )}
        {showIntegrationError && !isIntegrationErrorClosed && (
          <IntegrationErrorBanner
            errors={integrationErrorDetails}
            closeBanner={closeIntegrationErrorBanner}
          />
        )}
      </>
    );
  }
  async componentDidMount() {
    this.props.getNoticeInfo();
    this.props.getSubscriptionInfo();

    // Call the permission check and update the state
    const canAccess = await profile.checkPermission(ACCOUNT, ACCESS);
    this.setState({ canAccessAccount: canAccess });
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.accountInfo !== this.props.accountInfo &&
      hasIPMAccountIntegration(
        this.props.accountInfo?.get("integrations") || Object.freeze([]),
      ) &&
      (!this.props.accountIntegrationLogs ||
        this.props.accountIntegrationLogs.size === 0)
    ) {
      this.props.fetchAccountIntegrationLogs();
    }
  }
}

const mapStateToProps = (state) => {
  return {
    profileInfo: state.getIn(["headers", "profile"]),
    accountId: state.getIn(["headers", "profile", "payclaim_account_id"]),
    accountList: state.getIn(["headers", "accountList"]),
    due_projects: state.getIn(["headers", "due_projects"]),
    due_contracts: state.getIn(["headers", "due_contracts"]),
    noticeNum: state.getIn(["headers", "noticeNum"]),
    setupExpand: state.getIn(["headers", "setupExpand"]),
    setupProcess: state.getIn(["headers", "setupProcess"]),
    free_trial: state.getIn(["headers", "free_trial"]),
    is_help_desk_mode: state.getIn(["headers", "is_help_desk_mode"]),
    accountConfig: state.getIn(["config", "accountConfig"]),
    config: state.getIn(["headers", "config"]),
    accountInfo: state.getIn(["manageAccount", "accountInfo"]),
    showSubscriptionNotice: state.getIn(["headers", "showSubscriptionNotice"]),
    subscriptionDetails: state.getIn(["headers", "subscriptionDetails"]),
    accountIntegrationLogs: state.getIn(["headers", "integrationLogs"]),
    showIntegrationError: state.getIn(["headers", "showIntegrationError"]),
    integrationErrorDetails: state
      .getIn(["headers", "integrationErrorDetails"])
      ?.toJS(),
    isDemoMode: state.getIn(["headers", "isDemoMode"]),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changeValue(name, value) {
      dispatch(actionCreators.setData(name, value));
    },
    changeAccount(accountId) {
      localStorage.setItem("close_checklist", JSON.stringify(false));
      localStorage.setItem("paylab_account_id", accountId);
    },
    getNoticeInfo() {
      dispatch(actionCreators.getNoticeInfo());
    },
    handleNotice(name, initialStatus, status) {
      if (status !== "") {
        dispatch(actionCreators.setData(name, status));
      } else {
        dispatch(actionCreators.setData(name, !initialStatus));
      }
    },
    setHelpDeskMode(event) {
      dispatch(
        actionCreators.setHelpDeskMode(event.target.name, event.target.checked),
      );
    },
    fetchAccountIntegrationLogs() {
      dispatch(actionCreators.getAccountIntegrationLogs());
    },
    getSubscriptionInfo() {
      dispatch(actionCreators.getSubscription());
    },
    closeSubscriptionNotice() {
      dispatch(actionCreators.closeSubscriptionNotice());
    },
    showSubscriptionModal() {
      dispatch(actionCreators.showSubscriptionModal());
    },
    closeIntegrationErrorBanner() {
      dispatch(actionCreators.closeIntegrationErrorBanner());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
